import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import configs from "constants/configs";
import { API_AUTH } from "service/common";
import { useSelector, useDispatch } from "react-redux";
import { Cookies } from "react-cookie";
export const BtnXuatDanhSach = () => {
  const dataSearch = useSelector((state) => state.dataSearchNhanVay);
  const xuatExcel = () => () => {
    let { customerName, phone, dateFrom, dateTo, status } = dataSearch;
    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }

    link = link +
      `quan-ly-nhan-vay/nhan-vay-xuat-excel?customerName=${customerName}&phone=${phone}&dateFrom=${dateFrom}&dateTo=${dateTo}&status=${status}`;
    API_AUTH.get(link).then((res) => {
      var uri = "data:application/vnd.ms-excel," + encodeURIComponent(res.data);
      var downloadLink = document.createElement("a");
      downloadLink.href = uri;
      downloadLink.download = "DanhSachNhanVay.xls";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    });
  };
  return (
    <>
      <a
        href={() => false}
        className="icon-bgnew color-print1"
        onClick={xuatExcel()}
      >
        <PopoversBootrap
          contentText="Xuất danh sách"
          titleText=""
          trigger={["hover", "focus"]}
          placement={"top"}
        >
          <i className="mdi mdi-download"></i>
        </PopoversBootrap>
      </a>
    </>
  );
};
